<template>
  <div>
    <div class="headers">
        <div class="col_width">
          <span>课程名称：{{courseName}}</span>
        </div>
        <div class="col_width">
          <span>课程课时：{{courseHours}}</span>
        </div>
        <div class="col_width">
          <span>章节数：{{lessonNum}}</span>
        </div>
        <div class="col_width">
          <span>总时长：{{playTimeTotalDis}}</span>
       </div>
    </div>
    <div class="box">
      <BInputText
        label-text="章节名称"
        v-model="lessonName"
        placeholder="章节名称"
      />
      <BBtnSecondary
        :img-src="require('@/assets/filter.png')"
        :clicked="doSearch"
        hidden-key="true"
        btn-txt="筛选"
        style="margin-left: 30px;"
      />
    </div>
    <div class="search-result">
      <Table
        :headers="headers"
        :tableData="classCourseList"
        :length="totalPages"
        :total-visible="7"
        :page-num="pageNum"
        v-model="pageNum"
        @input="doSearch(false)"
      >
        <template v-slot:actions="item">
          <div v-if="item.data.status == '03'" style="display:flex;flex-direction:row;justify-content: center;">
              --
          </div>
          <div
            v-else
            style="display: flex; flex-direction: row; justify-content: center"
          >
            <div  class="btn-detail"  @click="handleTimeDetail(item)">
              时间设置
            </div>
          </div>
        </template>
      </Table>
    </div>
  </div>
</template>
<script>
import { searchInfoInit,searchInfoList} from "@/api/classManagement";
import BInputText from "../../components2/BInputText";
import BBtnSecondary from "../../components2/BBtnSecondary";
import Table from "../../components2/Table";
import EditTimeDialog from "@/views/business/popComponents/EditTimeDialog";
import Hub from "../../events/Hub";
export default {
  components: {
    Table,
    BInputText,
    BBtnSecondary,
  },
  data() {
    return {
      loading: false,
      totalPages: 0,
      pageNum: 1,
      pageCount: 10,
      totalCount: 0,
      data_classId: "",
      searchParam: {},
      snackbarObj: {
        snackbar: false,
        timeout: -1,
        color: "",
        text: "",
      },
      headers: [
        { text: "ID", value: "indexNum", sortable: false, align: "center", width: '4%' },
        { text: "章节名称", value: "lessonName", sortable: false, align: "center", width: '20%' },
        { text: "章节区分", value: "lessonTypeName", sortable: false, align: "center", width: '15%' },
        { text: "章节时长", value: "playTimeTotalDis", sortable: false, align: "center", width: '10%' },
        { text: "上课期间", value: "learnDuration", sortable: false, align: "center", width: '20%' },
        { text: "状态", value: "statusName", sortable: false, align: "center", width: '10%' },
        { text: "操作", value: "actions", sortable: false, align: "center" },
      ],
      classCourseList: [],
      data: {},
      courseName: "",
      courseHours: 0,
      lessonNum: 0,
      playTimeTotalDis: "",
      lessonName: "",
      returnData: "",
      navi: [
        {name: "class-management"},
        {name: "class-management-course"},
      ],
    };
  },
  mounted() {
    this.$store.commit('SET_NAVI_DATA', this.navi);
    this.data_classId = this.$store.state.public_classId
    this.searchInfoInit();
    this.$nextTick(
      function() {
        Hub.$on("modal-confirm", this.set);
      }.bind(this)
    );
  },
  // // 页面载入之前
  // beforeRouteEnter(to, from, next) {
  //   next((vm) => {
  //     vm.classId = vm.$route.params.classId
  //     // 页面初期化
  //     vm.searchInfoInit()
  //   });
  // },
  methods: {
    
    async searchInfoInit () {
      const data = await searchInfoInit(this.data_classId);
      console.log(data)
      if (data.data.data != null || data.data.data === "") {
        this.courseName = data.data.data.courseName;
        this.courseHours = data.data.data.courseHours;
        this.lessonNum = data.data.data.lessonNum;
        this.playTimeTotalDis = data.data.data.playTimeTotalDis;
      }
      this.doSearch(true);
    },
    // 点击查询
    doSearch(flag) {
      this.loading = true;
      if (flag) {
        this.totalPages = 0;
        this.pageNum = 1;
        this.pageCount = 10;
        this.totalCount = 0;
      }
      this.searchList();
    },
    // 查询page列表
    async searchList() {
      var param = {
        page: this.pageNum,
        limit: this.pageCount,
        classId: this.data_classId,
        lessonName: this.comUtils.trim(this.lessonName),
      };
      // 把查询条件存入缓存
      const data = await searchInfoList(param);
      console.log(data)
      if (data.data.searchList != null || data.data.searchList === "") {
        this.classCourseList = data.data.searchList;
      }
      this.totalCount = data.data.totalCounts;
      this.totalPages = Math.ceil(this.totalCount / this.pageCount);
      this.loading = false;
    },
    // 点击时间设置
    handleTimeDetail(item) {
      console.log(item)
      this.data = {
        lessonId: item.data.lessonId,
        classId: this.data_classId,
        lessonName: item.data.lessonName,
        lessonType: item.data.lessonType,
        startTime: item.data.startTime,
        endTime: item.data.endTime,
      };
      Hub.$emit("open-modal");
      Hub.$emit("set-modal-data", this.data, "时间设置", EditTimeDialog);
    },
    set(value) {
      console.log(value)
      if(value == 1) {
        this.doSearch(true)
      }
    },
  },
  destroyed() {
    Hub.$off("modal-confirm", this.set);
  },
};
</script>

<style lang="scss" scoped>
.search-result {
  display: block;
  position: relative;
  margin: 30px 25px 5px 25px;
}
.headers {
  display: flex;
  margin: 30px 0px 5px 30px;
}
.search-functions {
  position: relative;
  top: 0;
  display: flex;
}
.search-result-summary {
  display: flex;
  align-items: center;
}
.search-result-summary .summary {
  margin: 0 50px 0 0;
}
.table-header-row {
  height: 67px;
  background: #f6f6f6;
}
.table-header-row th {
  text-align: left;
  padding: 10px;
}
.table-result-row {
  height: 78px;
  font-weight: 500;
  color: #333333;
}
.table-result-row td {
  border-bottom: 1px solid #ebebeb;
  padding: 10px;
  text-align: left;
}
.btn-detail {
  margin: 0 20px 0 20px;
  color: #0171a3;
  cursor: pointer;
}
.btn-delete {
  color: #fd1f58;
  cursor: pointer;
}
.box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.box-left {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  border-right: 1px solid black;
}
.box-right {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
}

.col_width {
  width: 20%;
}
</style>
